

import { AnimatePresence } from 'framer-motion';
import React from 'react';
import styled from 'styled-components';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { useResolve } from '../../Container';
import { ProfileModel } from '../../ProfileModel';
import { HelpButton } from './HelpButton';
import { HelpController } from './HelpController';
import { HelpVideoView } from './HelpVideoView';

const Frame = styled.div`
    position: fixed;
    inset: 5rem 0 0;
    z-index: 10;
    pointer-events: none;
    & > * {
        pointer-events: auto;
    }
`;

export const HelpSupport = () => {
    const me = useResolve(ProfileModel);
    const { activeVideo } = useObserver(useResolve(HelpController));
    const params = new URLSearchParams(window.location.search);
    const ui = params.get('ui') !== '0';
    if (!ui) return null;
    if (me.id === 'US000000ANON') return null;
    if (me.id === 'US0000000000') return null;
    return <Frame id="help">
        <AnimatePresence>
            {activeVideo && <HelpVideoView {...activeVideo} />}
        </AnimatePresence>
        <HelpButton />
    </Frame>;
};
